import { Component } from '@angular/core';

@Component({
  selector: 'shc-auth-root',
  templateUrl: './auth-root.component.html',
  styleUrls: ['./auth-root.component.scss']
})
export class AuthRootComponent {

  constructor() { }

}
